"use client";

import Image from "next/image";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { AlertCircle, Compass, Home, Phone } from "lucide-react";

export default function NotFound() {
  return (
    <div
      className="min-h-screen bg-gradient-to-b from-orange-50 via-amber-50 to-yellow-50 flex items-center justify-center p-4"
      dir="rtl"
    >
      <div className="max-w-lg w-full">
        <Card className="border-2 border-orange-200 shadow-xl overflow-hidden">
          <CardContent className="p-8 space-y-6 text-center">
            <div className="flex justify-center">
              <Image
                src="/logo-1230.png"
                alt="ידידים - סיוע בדרכים"
                width={240}
                height={96}
                className="h-24 w-auto"
                priority
              />
            </div>

            <div className="space-y-3">
              <p className="inline-flex items-center gap-2 rounded-full bg-white/90 border border-orange-200 px-4 py-1 text-sm font-semibold text-orange-800">
                <AlertCircle className="h-4 w-4" />
                העמוד שחיפשת לא נמצא
              </p>
              <h1 className="text-3xl font-serif font-black text-orange-900">
                אבדה לנו הדרך...
              </h1>
              <p className="text-base text-orange-800">
                הקישור שאליו ניסית להגיע לא זמין או שנמחק. בואו נחזור יחד אל
                הדרך הבטוחה 💛
              </p>
            </div>

            <div className="rounded-2xl border border-orange-200 bg-white/80 p-5 text-right space-y-3">
              <p className="text-sm text-orange-900 font-semibold">
                מה אפשר לעשות עכשיו?
              </p>
              <ul className="text-sm text-orange-800 space-y-1 list-disc pr-4">
                <li>בדקו שהקישור הוקלד במדויק</li>
                <li>חזרו אל דף הבית להתחיל מהתחלה</li>
                <li>צרו קשר עם המוקד שלנו לקבלת סיוע</li>
              </ul>
            </div>

            <div className="grid gap-3">
              <Button
                asChild
                size="lg"
                className="w-full bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-base"
              >
                <Link href="/">
                  <Home className="h-5 w-5 ml-2" />
                  חזרה לדף הבית
                </Link>
              </Button>
              <Button
                size="lg"
                variant="outline"
                className="w-full justify-center text-base"
                onClick={() => window.history.back()}
              >
                <Compass className="h-5 w-5 ml-2" />
                חזרה לעמוד הקודם
              </Button>
              <Button
                size="lg"
                className="w-full bg-orange-100 text-orange-900 hover:bg-orange-200 text-base"
                onClick={() => (window.location.href = "tel:1230")}
              >
                <Phone className="h-5 w-5 ml-2" />
                צרו קשר עם המוקד 1230
              </Button>
            </div>

            <p className="text-xs text-orange-800/70 italic">
              צוות ידידים תמיד כאן בשבילכם 🧡
            </p>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
